export default "__VITE_ASSET__MJ0gD7dP__"